"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fdrMergePaginatedItems = exports.fdrMergePage = void 0;
function fdrMergePage(existing, incoming, itemsCount) {
    const perPageChanged = (existing === null || existing === void 0 ? void 0 : existing.perPage) !== incoming.perPage;
    const countedPages = Math.floor((itemsCount - 1) / incoming.perPage);
    const pageNumber = perPageChanged
        ? Math.max(incoming.page, countedPages)
        : Math.max(incoming.page, existing === null || existing === void 0 ? void 0 : existing.page);
    const resultsTotal = perPageChanged
        ? incoming.total
        : Math.max(incoming.total, existing === null || existing === void 0 ? void 0 : existing.total);
    return Object.assign(Object.assign({}, incoming), { page: pageNumber, total: resultsTotal });
}
exports.fdrMergePage = fdrMergePage;
function fdrMergePaginatedItems(incomingPage, existingPage, existingItems, incomingItems) {
    const { page, perPage } = incomingPage || {};
    const resultsTotal = Math.max(incomingPage.total, (existingPage === null || existingPage === void 0 ? void 0 : existingPage.total) || 0);
    if (!resultsTotal)
        return [];
    const storedItemsCount = existingItems.length;
    const firstIncomingItemIndex = page * perPage;
    const storedElements = existingItems.slice(0, firstIncomingItemIndex);
    const emptyElements = Array.from({
        length: firstIncomingItemIndex - storedItemsCount,
    }).map(() => null);
    const postElements = existingItems.slice(firstIncomingItemIndex + incomingItems.length);
    const toIndex = resultsTotal === existingItems.length
        ? postElements.length
        : postElements.length - (postElements.length % perPage);
    return [
        ...storedElements,
        ...emptyElements,
        ...incomingItems,
        ...postElements.slice(0, toIndex),
    ].slice(0, resultsTotal);
}
exports.fdrMergePaginatedItems = fdrMergePaginatedItems;
//# sourceMappingURL=pagination.js.map